import { createRouter, createWebHistory } from 'vue-router'
const loadView = (view) => { return () => import(/* webpackChunkName: "about" */ `../views/${view}.vue`) }

const routes = [
  {
    path: '/',
    name: 'Home',
    component: loadView('Home')
  },
  {
    path: '/about',
    name: 'About',
    component: loadView('About')
  },
  {
    path: '/googleauth',
    name: 'GoogleAuth',
    component: loadView('GoogleAuth')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
